<template>
  <button
    v-on:click="$emit('btn-click')"
    :disabled="disabled"
    class="add-to-cart-btn">
    <slot>{{ t('button') }}</slot>
  </button>
</template>

<script>
export default {
  name: 'AdvButton',
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      version: '0.0.1'
    }
  }
}
</script>
